export const victoryColorScale: string[] = [
    '#fcda43',
    '#73f2f1',
    '#fe7887',
    '#363b3f',
    '#50bf3c',
    '#aeafae',
    '#ad942a',
    '#199593',
];
